<p-toast position="top-right" key="update" >

  <ng-template let-message pTemplate="message" >

    <div style="display:flex; gap:12px; width:320px"
         (mouseenter)="updateService.pause()"
         (mouseleave)="updateService.resume()">

      <i class="pi pi-refresh" style="font-size:20px; margin-top:4px"></i>

      <div style="flex:1; display:flex; flex-direction:column; gap:8px">

        <div style="font-weight:600">
          {{ message.summary }}
        </div>

        <div style="font-size:13px">
          {{ message.detail }}
        </div>

        <div style="font-size:12px; color:#6b7280">
          Se actualizará en
          <b>{{ updateService.countdown() }}</b> segundos...
        </div>

        <div class="progress">
          <div class="bar"
               [style.width.%]="(updateService.countdown() / 60) * 100">
          </div>
        </div>

        <button
          pButton
          type="button"
          label="Actualizar ahora"
          icon="pi pi-refresh"
          class="p-button-sm w-full"
          (click)="updateService.updateApp()">
        </button>

      </div>

    </div>

  </ng-template>

</p-toast>
